import { DELETE_BANNERS_ERROR, DELETE_BANNERS_START, DELETE_BANNERS_SUCCESS } from '../../types';

export default function delete_banners(state, action) {
  switch (action.type) {
    case DELETE_BANNERS_START:
      return { ...state };
    case DELETE_BANNERS_SUCCESS:
      console.log(action.results)
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case DELETE_BANNERS_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
